// DashMenu.js - Dashboard com abas (Resumo | Vendas | Contabilidade)
// ✅ Ícones SVG do SharedComponents (sem emojis)
// =============================================

import React, { useState } from 'react';
import './DashMenu.css';
import { Icon } from './SharedComponents';
import DashboardVendas from './DashboardVendas';
import DashboardContabilidade from './DashboardContabilidade';

/* ─────────────────────────────────────────────
   Componente de Barra de Progresso para Vendas
───────────────────────────────────────────── */
export function SalesBar({ month, value, maxValue = 100000 }) {
    const percentage = Math.min(100, (value / maxValue) * 100);
    return (
        <div className="sales-bar-item">
            <div className="sales-bar-info">
                <span className="sales-bar-month">{month}</span>
                <span className="sales-bar-value">
                    {value.toLocaleString('pt-MZ', { style: 'currency', currency: 'MZN', maximumFractionDigits: 0 })}
                </span>
            </div>
            <div className="sales-bar-bg">
                <div
                    className="sales-bar-fill"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
}

/* ─────────────────────────────────────────────
   Card Contabilístico com Progress Circle
───────────────────────────────────────────── */
export function MetricCard({ title, value, icon, change, changeType = 'positive', percent, progressColor }) {
    const numericValue = parseFloat(String(value).replace(/[^0-9.-]/g, '')) || 0;
    const changePercent = change ? parseFloat(String(change).replace(/[^0-9.-]/g, '')) : percent || 0;
    const isPositive = changeType === 'positive';
    const displayPercent = Math.abs(changePercent);
    const circleColor = progressColor || (isPositive ? 'var(--color-success)' : 'var(--color-danger)');

    return (
        <div className="metric-card">
            <div className="metric-card-icon">
                <Icon name={icon} size={28} color="white" />
            </div>
            <div className="metric-card-info">
                <h3>{title}</h3>
                <p className="metric-value">{value}</p>
                {change && (
                    <span className={`metric-change ${changeType}`}>{change}</span>
                )}
            </div>
            <div className="metric-progress">
                <svg width="70" height="70" viewBox="0 0 70 70">
                    <circle cx="35" cy="35" r="28" fill="none" stroke="var(--color-light)" strokeWidth="5" />
                    <circle
                        cx="35" cy="35" r="28" fill="none"
                        stroke={circleColor} strokeWidth="5" strokeLinecap="round"
                        strokeDasharray="175.93"
                        strokeDashoffset={175.93 - (175.93 * displayPercent / 100)}
                        transform="rotate(-90 35 35)"
                    />
                </svg>
                <div className="metric-progress-percentage">
                    <p style={{ color: circleColor }}>
                        {isPositive ? '+' : ''}{displayPercent}%
                    </p>
                </div>
            </div>
        </div>
    );
}

/* ══════════════════════════════════════════════
   ABAS — com ícones SVG do SharedComponents
══════════════════════════════════════════════ */
const ABAS = [
   
    { id: 'vendas', label: 'Vendas & CRM', icone: 'storefront' },
    { id: 'contabilidade', label: 'Contabilidade', icone: 'account_balance' },
];



/* ══════════════════════════════════════════════
   DASHBOARD MENU - CONTEÚDO PRINCIPAL
══════════════════════════════════════════════ */
export default function DashMenu() {
    const [abaAtiva, setAbaAtiva] = useState('vendas');

    return (
        <div className="dashmenu-wrapper">
            {/* ───── ABAS ───── */}
            <nav className="dashmenu-abas">
                {ABAS.map(aba => (
                    <button
                        key={aba.id}
                        className={`aba-btn ${abaAtiva === aba.id ? 'ativa' : ''}`}
                        onClick={() => setAbaAtiva(aba.id)}
                    >
                        <span className="aba-icone">
                            <Icon
                                name={aba.icone}
                                size={18}
                                color={abaAtiva === aba.id ? '#fff' : 'currentColor'}
                            />
                        </span>
                        <span className="aba-label">{aba.label}</span>
                    </button>
                ))}
            </nav>

            {/* ───── CONTEÚDO ───── */}
            <div className="dashmenu-conteudo">
                
                {abaAtiva === 'vendas' && <DashboardVendas />}
                {abaAtiva === 'contabilidade' && <DashboardContabilidade />}
            </div>
        </div>
    );
}